import React from "react"
import { connect } from "react-redux"
import { Route, Switch } from "react-router-dom"
import { push } from "connected-react-router"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import { omit, findIndex, compact, keys } from 'lodash'
import PropTypes from "prop-types"

import {str2date, date2str} from "../../../lib/Tools"
import { updateProductData } from "../actions/index"
import { getSelections } from "../selectors"
import {products} from "../../../../data"
import Page from "../components/FixedBarPage"
import MyCalendar from './Reservation.Calendar'
import TimePicker from './Reservation.Time'
import PersonsPicker from './Reservation.Persons'
import AgePersonsPicker from './Reservation.AgePersons'
import MenuPicker from './Reservation.Menu'
import DrinksPicker from './Reservation.Drinks'

import './ReservationPage.less'

const calculateSteps = (product) => {
  const steps = []
  if (product.timetable) steps.push({key: "day", label: "日期"})
  if (!product.timetable.allDay) steps.push({key: "shift", label: "预约时间"})
  if (product.price && product.price.ageAware) steps.push({key: "agePersons", label: "人数"}) 
  else steps.push({key: "persons", label: "人数"})
  if (product.menus) steps.push({key: "menus", label: "选择菜单"})
  if (product.drinks) steps.push({key: "drinks", label: "饮料"})
  return steps
}

class ReservationPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      day: this.props.productSelections.day || "",
      shift: this.props.productSelections.shift || "",
      persons: this.props.productSelections.persons || "",
      agepersons: this.props.productSelections.agepersons || {},
      menus: this.props.productSelections.menus || [],
      drinks: this.props.productSelections.drinks || []
    }
    this.steps = calculateSteps(props.product)
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Hacemos esto para no hacer un rerender raro que rompe las animaciones al hacer un POP
    const reallySameMatch = () => {
      let really = true
      Object.entries(this.props.match).forEach(([key, val]) => {
        if (key == "params") {
          if (nextProps.match.params.id != val.id) really = false
        } 
        else if (nextProps.match[key] != val) really = false
      })
      return really
    }
    const changes = compact(Object.entries(nextProps).map(([key, val]) => this.props[key] !== val && key))
    if (changes.length == 1 && changes[0] == "match" && reallySameMatch()) return false
    else return true
  }

  static getDerivedStateFromProps(props, state) {
    if (props.pathname.includes('/catalogo/reservation/formpage/')) return null
    else return {step: props.pathname.split('/')[5] || "day"}
  }

  findIndex(step) {
    return findIndex(this.steps, ['key', step])
  }

  getTotalMenus() {
    return this.state.menus.map(item => item.count).reduce((a, b) => a + b, 0)
  }

  getTotalDrinks() {
    return this.state.drinks.map(item => item.count).reduce((a, b) => a + b, 0)
  }

  checkoutAge() {
    return (
      this.state.agepersons.g > 0
      || keys(this.state.agepersons).some(k => (this.state.agepersons[k] > 0 && k > 19))
    )
  }

  
  checkStepReady(step) {
    if (step == "menus") {
      return this.getTotalMenus() > 0 && this.getTotalMenus() >= this.state.persons
    } else if (step == "drinks") {
      return this.checkStepReady("menus") && this.getTotalDrinks() == this.getTotalMenus()
    }
    else if (step == "agePersons") { 
      return this.checkoutAge()
    }
    else return this.state[step]
  }
  
  submitAllData() {
    this.props.updateProductData({[this.props.product._id]: omit(this.state, ['step', 'movement'])})
    this.props.push(`/catalogo/reservation/formpage/${this.props.product._id}`)
  }

  stepsComponents() {
    const { product } = this.props
    return {
      day: {
        label: "日期",
        key: "day",
        component: (() => (
          <MyCalendar
            key="calendar" 
            timetable={product.timetable}
            onChange={date => this.setState({day: date2str(date)})}
            value={this.state.day ? str2date(this.state.day) : ""}
          />
        ))
      },
      shift: {
        label: "预约时间",
        key: "shift",
        component: (() => (
          <TimePicker 
            key="timepicker"
            timetable={product.timetable}
            date={this.state.day ? str2date(this.state.day) : ""}
            value={this.state.shift}
            onChange={hour => this.setState({shift: hour})}
          />
        ))
      },
      persons: {
        label: "人数",
        key: "persons",
        component: (() => (
          <PersonsPicker
            key="personspicker"
            value={this.state.persons}
            onChange={persons => this.setState({persons})}
          />
        ))
      },
      agePersons: {
        label: "人数",
        key: "agePersons",
        component: (() => (
          <AgePersonsPicker
            key="agepersonspicker"
            price={product.price}
            value={this.state.agepersons}
            checkoutAge={this.checkoutAge()}
            onChange={agepersons => this.setState({agepersons})}
          />
        ))
      },
      menus: {
        label: "选择菜单",
        key: "menus",
        component: (() => (
          <MenuPicker 
            key="menupicker"
            menus={product.menus}
            persons={this.state.persons}
            value={this.state.menus}
            onChange={menus => this.setState({menus})}
          />
        ))
      },
      drinks: {
        label: "饮料",
        key: "drinks",
        component: (() => (
          <DrinksPicker 
            key="drinkspicker"
            drinks={product.drinks}
            persons={this.state.persons}
            value={this.state.drinks}
            totalmenus={this.getTotalMenus()}
            onChange={drinks => this.setState({drinks})}
          />
        ))
      }
    }
  }

  nextStep() {
    this.props.push(`/catalogo/reservation/selections/${this.props.product._id}/${this.steps[this.findIndex(this.state.step) + 1].key}`)
  }

  previousStep() {
    this.props.push(`/catalogo/reservation/selections/${this.props.product._id}/${this.steps[this.findIndex(this.state.step) - 1].key}`)
  }

  render() {
    const { step } = this.state
    return  (
      <Page
        title="预订过程"
        onFooterClick={() => (this.findIndex(this.state.step) == this.steps.length - 1 ? this.submitAllData() : this.nextStep())}
        footerButton
        pillButton={false}
        footerDisabled={!this.checkStepReady(step)}
        footerLabel="下一步"
        transparentBar
        containerProps={{ id: "ReservationPage" }}
      >

        <div className="tituloreserva">
          预订信息
        </div>
        <div className="navigationBar">
          {this.steps.map((tab, i) => (
            <div 
              className={`tab ${i <= this.findIndex(step) ? "selected" : "notselected"}`} 
              key={tab.key}
            >
              <p>{tab.label}</p>
              <div className={`dot ${this.checkStepReady(tab.key) ? "selected" : "notselected"}`}  />
            </div>
          ))
          }  
        </div>  
        <Route
          render={({ location }) => (
            <TransitionGroup className={`transition ${this.props.action}`} style={{backgroundColor: step == "menus" || step == "drinks" || step == "agePersons" ? "#EDEDED" : "white"}}>
              <CSSTransition key={window.matchMedia("(min-width: 735px)").matches ? "none" : step} classNames="picker" unmountOnExit timeout={1000}>       
                <Switch location={location}>
                  {this.steps.map((tab) => (
                    <Route
                      key={tab.key}
                      path={`/catalogo/reservation/selections/:id/${tab.key}`}
                      component={this.stepsComponents()[tab.key].component}
                    />
                  ))
                  }
                  <Route
                    key={`calendar`}
                    exact
                    path={`/catalogo/reservation/selections/:id`}
                    component={this.stepsComponents().day.component}
                  />
                </Switch>
              </CSSTransition>
            </TransitionGroup>)}
        >
        </Route>
      </Page>
    )
  }
}

ReservationPage.propTypes = {
  product: PropTypes.object.isRequired,
  updateProductData: PropTypes.func,
  productSelections: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  const product = products[ownProps.match.params.id] || products[encodeURIComponent(ownProps.match.params.id)]
  return {
    product,
    action: state.router.action,
    pathname: state.router.location.pathname,
    productSelections: getSelections(state, ownProps)[product._id] || ""
  }
}

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
  updateProductData: payload => dispatch(updateProductData(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReservationPage)



// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/ReservationPage.jsx